module.exports = __webpack_public_path__ + "static/media/information_stroke.abe9510f.svg";